import qs from 'qs';

/** Последние фильтры главной «Визитов»: после экрана дома и повторного входа они не теряются. */
export const STORAGE_KEY = 'chronaDashboardQuery';

/** Адрес без периода и страницы: возврат на главную открывает текущий период с первой страницы. */
export const toSavedSearch = (search: string): string => {
  const parsed = qs.parse(search, { ignoreQueryPrefix: true });
  delete parsed.at;
  delete parsed.from;
  delete parsed.to;
  delete parsed.page;
  return qs.stringify(parsed, { arrayFormat: 'repeat' });
};

/** Сохранённый адрес без «?»; хранилище недоступно (приватный режим, запрет) - пусто. */
export const loadSavedSearch = (): string => {
  try {
    return globalThis.localStorage.getItem(STORAGE_KEY) || '';
  } catch (e) {
    console.warn('Сохранённые фильтры недоступны', e);
    return '';
  }
};

/** Пустой адрес («Сбросить», «Все объекты» без фильтров) стирает сохранённое. */
export const saveSearch = (search: string) => {
  const saved = toSavedSearch(search);
  try {
    if (saved) globalThis.localStorage.setItem(STORAGE_KEY, saved);
    else globalThis.localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // Без хранилища фильтры живут только в адресе.
    console.warn('Фильтры не сохранены', e);
  }
};
